import {merge} from "lodash";
import {DateTime} from "luxon";
import {isDateBetween} from "@commons/utils/util";
import {DateTimeJSOptions, MonthNumbers} from "luxon/src/datetime";

export type ObjectFactory<T> = (json?: Partial<T>) => T;

/**
 * le date da backend sono rappresentate da una stringa yyyy-MM-dd
 * i time stamp hanno invece in seguente format:yyyy-MM-dd'T'HH:mm:ss
 * FPNetDate rappresenta una data o un timestamp, in alternativa null
 */
export type FPNetDate = string | null; // yyyy-MM-dd o yyyy-MM-dd'T'HH:mm:ss
export type CDate = string | null; // data nel formato yyyyMMdd
export type PeriodoType = 'today' | 'm' | 'b' | 't' | 'q' | 's' | 'cy' | 'fy' | 'custom' | 'p' | 'all' | null;

export interface TabellaGenerica {
    id: number | string,
    descrizione: string,
}

export interface Trace {
    userName: string | null,
    timeStamp: string | null, // timestamp nel formato "2018-09-10T11:33:21"
}

export class Trace {
    static factory: ObjectFactory<Trace> = (json?) => {
        return merge<Trace, Partial<Trace> | undefined>({
            userName: null,
            timeStamp: null
        }, json);
    };
}

export type UserTrace = Trace;
//export type IndiceMese = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
export type IndiceMese = MonthNumbers;

export interface Periodo {
    anno: number,
    mese: IndiceMese,
    idDip?: number,
}

export class Periodo {
    static getDate = (periodo: Pick<Periodo, 'anno' | 'mese'>, opts?: DateTimeJSOptions) => {
        return DateTime.fromObject({year: periodo.anno, month: periodo.mese}, opts);
    };

    static getInizioMese(periodo: Pick<Periodo, 'anno' | 'mese'>): DateTime {
        return DateTime.fromObject({year: periodo.anno, month: periodo.mese}).startOf("month").startOf("day");
    }

    static getFineMese(periodo: Pick<Periodo, 'anno' | 'mese'>): DateTime {
        return DateTime.fromObject({year: periodo.anno, month: periodo.mese}).endOf("month").startOf("day");
    }

    static isBetween = (periodo: Pick<Periodo, 'anno' | 'mese'>, minDate: string, maxDate: string) => {
        const dtGiornata = Periodo.getDate(periodo);
        return isDateBetween(minDate, maxDate, dtGiornata.toFormat("yyyy-LL-dd"));
    };
}

export interface PeriodoGiustificato {
    meseDA: number,    // int
    giornoDA: number,  // int
    meseA: number,     // int
    giornoA: number,   // int
    codGiustificativo: string,  // String
}

export interface Intervallo {
    startDate: Date | null,
    endDate: Date | null,
}